module.exports = __webpack_public_path__ + "static/images/logo-home-8f86be80.png";